
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20 20\" id=\"icon-arrow-right-white\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M10.003,0C4.479,0,0,4.474,0,9.991c0,5.517,4.479,9.989,10.003,9.989c5.524,0,10.004-4.473,10.004-9.989\r\n\tC20.007,4.474,15.527,0,10.003,0z M16.874,10.304l-6.472,6.463c-0.15,0.148-0.402,0.15-0.55,0.002L8.67,15.591\r\n\tc-0.155-0.159-0.144-0.394-0.005-0.551l3.851-3.834l-9.134-0.002c-0.219,0.001-0.396-0.181-0.395-0.386L2.986,9.175\r\n\tc0.002-0.212,0.18-0.391,0.396-0.392l9.136,0.001L8.669,4.948c-0.142-0.154-0.153-0.397,0-0.55l1.187-1.187\r\n\tC10,3.062,10.252,3.066,10.403,3.218l6.47,6.47C16.984,9.8,17.02,9.867,17.02,9.995C17.02,10.114,16.982,10.19,16.874,10.304z\"/> </symbol>";
module.exports = sprite.add(image, "icon-arrow-right-white");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/arrow-right-white.svg
 ** module id = 142
 ** module chunks = 24
 **/